import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "charcter-shoppingcart" }
const _hoisted_3 = { class: "me-2 py-0 px-2 charcter-message speech-bubble speech-bubble-right speech-bubble-bg-white speech-bubble-border-accent2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "視聴リスト", -1)
const _hoisted_5 = {
  key: 0,
  class: "d-block"
}
const _hoisted_6 = { class: "me-1 fs-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "charcter-character" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-caret-left-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z" })
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "p-4 flex-grow-1 overflow-scroll",
  style: {"max-height":"100vh"}
}
const _hoisted_11 = { class: "position-relative" }
const _hoisted_12 = { class: "mt-4 mb-4 fs-4 fw-bold" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "my-3 text-center fs-6 fw-bold" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "fs-6 table table-striped table-bordered align-top webtan-shoppingcart-table" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("thead", { class: "table-light text-center" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "日時"),
    /*#__PURE__*/_createElementVNode("th", null, "時間"),
    /*#__PURE__*/_createElementVNode("th", null, "番号"),
    /*#__PURE__*/_createElementVNode("th", null, "タイトル"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_20 = { class: "col-6 text-break" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 2,
  class: "ms-2 small fw-normal"
}
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "text-center shoppingcart-submit-btn" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "mt-3 text-center shoppingcart-close-btn" }
const _hoisted_31 = {
  key: 0,
  class: "my-5"
}
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 mb-4 fs-4 fw-bold" }, "視聴リスト（申込済）", -1)
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "my-5 text-center fs-6 fw-bold" }, "視聴リスト（申込済み）は空です", -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "fs-6 table table-striped table-bordered align-top webtan-shoppingcart-table" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("thead", { class: "table-light text-center" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "日時"),
    /*#__PURE__*/_createElementVNode("th", null, "時間"),
    /*#__PURE__*/_createElementVNode("th", null, "番号"),
    /*#__PURE__*/_createElementVNode("th", null, "タイトル"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_40 = { class: "col-6 text-break" }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { key: 1 }
const _hoisted_44 = {
  key: 2,
  class: "ms-2 small fw-normal"
}
const _hoisted_45 = { class: "text-center" }
const _hoisted_46 = { class: "d-inline-flex" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-start icon-me-2 icon-zoom" }, "視聴", -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = ["onClick"]

import { onMounted } from 'vue';

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ShoppingCart',
  props: {
    sessions: { type: Object },
    cart: { type: Object },
    entryList: { type: Object },
    shoppingCart: { type: Boolean },
    login: { type: Boolean },
    webinarMainLabel: { type: String },
    webinarSubLabel: { type: String }
  },
  emits: ['removeItem', 'cancelItem', 'toggleShoppingCart', 'submitForm', 'openExternalLink'],
  setup(__props, { emit: emits }) {

const props = __props;

  
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  

  const removeItem = (id: string) => {
    emits('removeItem', id);
  }

  const cancelItem = (session: object) => {
    emits('cancelItem', session);
  }

  const toggleShoppingCart = () => {
    emits('toggleShoppingCart');
  }
  
  const onClickStopPropagation = (evt) => {
  	// @click.stopclick="void"
  	// @click.stopclick="onClickStopPropagation"
  	// だとダメだったので、ふつうのハンドラ内でstopPropagation();
  	// Vue 3では.stopか。。。
  	evt.stopPropagation();
  }

  const submitForm = () => {
    emits('submitForm');
  }

  const openExternalLink = (url: string) => {
    emits('openExternalLink', url);
  }

  const findSession = (cart: string[]) => {
    let sessions = [];
    if (cart) {
      cart.forEach((row) => {
        props.sessions.forEach((session) => {
          if ('undefined' != typeof(session.layout_id) && 'undefined' != typeof(session.layout_id.toString) && row === session.layout_id.toString()) {
            sessions.push(session);
          }
        });
      });
    }
    sessions = sessions.sort((a, b) => {
      return a.sortkey - b.sortkey;
    });
    return sessions;
  }

  onMounted (() => {
  	// ショッピングカートの有無でCSS切り替えできるように
  	// でもApp rootと右マージン指定してる要素が違ってて
  	// サイトによって差異がでるとアレなので、bodyにクラス名つける
  	// たぶんVueの作法じゃないけど気にしない方向で
    const bodyElem = document.getElementsByTagName('body')[0];
    if (bodyElem) {
    	bodyElem.classList.add('webtan-event-has-shoppingcart');
    }
  });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "position-fixed top-0 end-0 h-100 d-flex shoppingcart-wrapper",
    style: {"z-index":"999"},
    onClick: _withModifiers(onClickStopPropagation, ["stop","prevent"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["appearance-none charcter-wrapper", __props.shoppingCart ? 'active' : '']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleShoppingCart()))
      }, [
        _createElementVNode("span", _hoisted_3, [
          _hoisted_4,
          (__props.cart && __props.entryList)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(__props.cart.length + __props.entryList.length), 1),
                _createTextVNode("件")
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_7
      ], 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([__props.shoppingCart ? 'active' : 'opacity-50', "shoppingcart h-100 d-flex bg-light"])
    }, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass([__props.shoppingCart ? 'rotate-180' : '', "p-1 appearance-none text-white bg-accent2 flex-shrink-1"]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleShoppingCart()))
      }, _hoisted_9, 2),
      (__props.shoppingCart)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                class: "p-3 position-absolute top-0 end-0 appearance-none fs-2 text-muted",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleShoppingCart())),
                style: {"z-index":"2"}
              }, "×")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_12, [
                _createTextVNode("視聴リスト"),
                (__props.login)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "（未申込）"))
                  : _createCommentVNode("", true)
              ]),
              (__props.cart && __props.cart.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createTextVNode("視聴リスト"),
                      (__props.login)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, "（未申込）"))
                        : _createCommentVNode("", true),
                      _createTextVNode("は空です")
                    ])
                  ]))
                : _createCommentVNode("", true),
              (__props.cart && __props.cart.length != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("table", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(findSession(__props.cart), (session, i) => {
                          return (_openBlock(), _createElementBlock("tr", { key: i }, [
                            _createElementVNode("td", null, _toDisplayString(session.date), 1),
                            _createElementVNode("td", null, _toDisplayString(session.timeStart) + "〜" + _toDisplayString(session.timeEnd), 1),
                            _createElementVNode("td", null, _toDisplayString(session.id), 1),
                            _createElementVNode("td", _hoisted_20, [
                              _createElementVNode("div", {
                                class: "fw-bold",
                                innerHTML: session.title
                              }, null, 8, _hoisted_21),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(session.speakers, (speaker, o) => {
                                return (_openBlock(), _createElementBlock("div", { key: o }, [
                                  (speaker.company)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "me-2",
                                        innerHTML: speaker.company
                                      }, null, 8, _hoisted_22))
                                    : _createCommentVNode("", true),
                                  (speaker.name)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(speaker.name), 1))
                                    : _createCommentVNode("", true),
                                  (speaker.name)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, "氏"))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]),
                            _createElementVNode("td", _hoisted_25, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "text-nowrap btn btn-secondary",
                                onClick: ($event: any) => (removeItem(session.layout_id))
                              }, "削除", 8, _hoisted_26)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("button", {
                  type: "button",
                  class: "px-3 px-lg-5 btn btn-lg btn-accent2 fw-bold",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (submitForm()))
                }, [
                  (!__props.login)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_28, "参加申込する（無料）"))
                    : _createCommentVNode("", true),
                  (__props.login)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, "追加申込する（無料）"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  type: "button",
                  class: "px-3 px-lg-5 btn btn-outline-secondary fw-bold",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleShoppingCart()))
                }, "もどる")
              ])
            ]),
            (__props.login)
              ? (_openBlock(), _createElementBlock("hr", _hoisted_31))
              : _createCommentVNode("", true),
            (__props.login)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _hoisted_33,
                  (__props.entryList && __props.entryList.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
                    : _createCommentVNode("", true),
                  (__props.entryList && __props.entryList.length != 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("table", _hoisted_38, [
                          _hoisted_39,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(findSession(__props.entryList), (session, i) => {
                              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                _createElementVNode("td", null, _toDisplayString(session.date), 1),
                                _createElementVNode("td", null, _toDisplayString(session.timeStart) + "〜" + _toDisplayString(session.timeEnd), 1),
                                _createElementVNode("td", null, _toDisplayString(session.id), 1),
                                _createElementVNode("td", _hoisted_40, [
                                  _createElementVNode("div", {
                                    class: "fw-bold",
                                    innerHTML: session.title
                                  }, null, 8, _hoisted_41),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(session.speakers, (speaker, o) => {
                                    return (_openBlock(), _createElementBlock("div", { key: o }, [
                                      (speaker.company)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: "me-2",
                                            innerHTML: speaker.company
                                          }, null, 8, _hoisted_42))
                                        : _createCommentVNode("", true),
                                      (speaker.name)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(speaker.name), 1))
                                        : _createCommentVNode("", true),
                                      (speaker.name)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_44, "氏"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]),
                                _createElementVNode("td", _hoisted_45, [
                                  _createElementVNode("div", _hoisted_46, [
                                    (session.watch && session.webinarMainURL && __props.webinarMainLabel)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "text-nowrap btn btn-accent",
                                          onClick: _withModifiers(($event: any) => (openExternalLink(session.webinarMainURL)), ["stop","prevent"])
                                        }, _hoisted_49, 8, _hoisted_47))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "ms-3 text-nowrap btn btn-secondary",
                                      onClick: ($event: any) => (cancelItem(session))
                                    }, "削除", 8, _hoisted_50)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 8, _hoisted_1))
}
}

})